import { useTypewriter } from 'react-simple-typewriter'

interface InputProps {
  onClick: (e: React.MouseEvent<HTMLInputElement>) => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  value: string
  thinStyle?: boolean
}

const searchPlaceholderTexts = [
  '"Jaqueta para -10° C"',
  '"Blusa com proteção UV"',
  '"Bota pra trilha impermeável"',
  '"Tênis de corrida iniciante"',
]

export const InputMaskSearch = ({
  onClick,
  onChange,
  value,
  thinStyle = false,
}: InputProps) => {
  const [text] = useTypewriter({
    words: searchPlaceholderTexts,
    loop: 0,
    typeSpeed: 50,
    deleteSpeed: 50,
    delaySpeed: 3000,
  })

  return (
    <input
      type="text"
      className={`flex-1 bg-transparent outline-none  text-secondary w-full placeholder:text-tertiary ${
        thinStyle ? 'text-xs' : 'desktop-body-regular-text2'
      }`}
      placeholder={text}
      onClick={(event) => {
        onClick(event)
      }}
      value={value}
      onChange={onChange}
      data-test-id="input-busca"
    />
  )
}
